/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import './_contactUs.scss';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import SecondaryButton2 from 'shared-components/components/SecondaryButton2';
import CircularProgress from '@mui/material/CircularProgress';
import HookTextField from 'shared-components/hooks/HookTextField';
import type { IFormValues } from 'formsTypes';
import { useMutation } from 'react-query';
import axios from 'axios';
import { Footer as NewFooter } from '../home/Footer';
import '../home/home.generated.css';
import type { IContactUs } from '../ClientFormTypes';

interface Icountries {
  name: string;
  value: string;
}
function TickIcon(): JSX.Element {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.875 10.3542L6.125 8.60417C5.95833 8.4375 5.75 8.35417 5.5 8.35417C5.26389 8.35417 5.0625 8.4375 4.89583 8.60417C4.71528 8.78472 4.625 9 4.625 9.25C4.625 9.48611 4.71528 9.6875 4.89583 9.85417L7.22917 12.1875C7.39583 12.3681 7.59722 12.4583 7.83333 12.4583C8.08333 12.4583 8.29861 12.3681 8.47917 12.1875L13.125 7.54167C13.2917 7.375 13.375 7.17361 13.375 6.9375C13.375 6.70139 13.2917 6.5 13.125 6.33333C12.9583 6.16667 12.75 6.08333 12.5 6.08333C12.2639 6.08333 12.0625 6.16667 11.8958 6.33333L7.875 10.3542ZM9 17.3333C7.84722 17.3333 6.76389 17.1181 5.75 16.6875C4.73611 16.2431 3.85417 15.6458 3.10417 14.8958C2.35417 14.1458 1.75694 13.2639 1.3125 12.25C0.881945 11.2361 0.666667 10.1528 0.666667 9C0.666667 7.84722 0.881945 6.76389 1.3125 5.75C1.75694 4.73611 2.35417 3.85417 3.10417 3.10417C3.85417 2.35417 4.73611 1.76389 5.75 1.33333C6.76389 0.888888 7.84722 0.666666 9 0.666666C10.1528 0.666666 11.2361 0.888888 12.25 1.33333C13.2639 1.76389 14.1458 2.35417 14.8958 3.10417C15.6458 3.85417 16.2361 4.73611 16.6667 5.75C17.1111 6.76389 17.3333 7.84722 17.3333 9C17.3333 10.1528 17.1111 11.2361 16.6667 12.25C16.2361 13.2639 15.6458 14.1458 14.8958 14.8958C14.1458 15.6458 13.2639 16.2431 12.25 16.6875C11.2361 17.1181 10.1528 17.3333 9 17.3333ZM9 15.5833C10.8194 15.5833 12.3681 14.9444 13.6458 13.6667C14.9375 12.375 15.5833 10.8194 15.5833 9C15.5833 7.18056 14.9375 5.63194 13.6458 4.35417C12.3681 3.0625 10.8194 2.41667 9 2.41667C7.18056 2.41667 5.625 3.0625 4.33333 4.35417C3.05556 5.63194 2.41667 7.18056 2.41667 9C2.41667 10.8194 3.05556 12.375 4.33333 13.6667C5.625 14.9444 7.18056 15.5833 9 15.5833Z' fill='#16A249' />
    </svg>
  );
}
function AddressIcon(): JSX.Element {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='40' height='40' rx='8' fill='#D9F6F5' />
      <path d='M22.35 28.775L17 26.9L12.35 28.7C12.0167 28.8333 11.7083 28.8 11.425 28.6C11.1417 28.3833 11 28.1 11 27.75V13.75C11 13.5333 11.0583 13.3417 11.175 13.175C11.3083 13.0083 11.4833 12.8833 11.7 12.8L16.35 11.225C16.5667 11.1583 16.7833 11.125 17 11.125C17.2167 11.1083 17.4333 11.1417 17.65 11.225L23 13.1L27.65 11.3C27.9833 11.1667 28.2917 11.2083 28.575 11.425C28.8583 11.625 29 11.9 29 12.25V26.25C29 26.4667 28.9333 26.6583 28.8 26.825C28.6833 26.9917 28.5167 27.1167 28.3 27.2L23.65 28.775C23.4333 28.8417 23.2167 28.8833 23 28.9C22.7833 28.9 22.5667 28.8583 22.35 28.775ZM22 26.55V14.85L18 13.45V25.15L22 26.55ZM24 26.55L27 25.55V13.7L24 14.85V26.55ZM13 26.3L16 25.15V13.45L13 14.45V26.3ZM24 14.85V26.55V14.85ZM16 13.45V25.15V13.45Z' fill='#01B3A8' />
    </svg>
  );
}
function EmailIcon(): JSX.Element {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='40' height='40' rx='8' fill='#D9F6F5' />
      <path d='M12 28C11.45 28 10.975 27.8083 10.575 27.425C10.1917 27.025 10 26.55 10 26V14C10 13.45 10.1917 12.9833 10.575 12.6C10.975 12.2 11.45 12 12 12H28C28.55 12 29.0167 12.2 29.4 12.6C29.8 12.9833 30 13.45 30 14V26C30 26.55 29.8 27.025 29.4 27.425C29.0167 27.8083 28.55 28 28 28H12ZM28 16L20.525 20.675C20.4417 20.725 20.35 20.7667 20.25 20.8C20.1667 20.8167 20.0833 20.825 20 20.825C19.9167 20.825 19.825 20.8167 19.725 20.8C19.6417 20.7667 19.5583 20.725 19.475 20.675L12 16V26H28V16ZM20 19L28 14H12L20 19ZM12 16V16.25C12 16.1667 12 16.0667 12 15.95C12 15.8167 12 15.675 12 15.525C12 15.1917 12 14.9417 12 14.775C12 14.6083 12 14.6167 12 14.8V14V14.8C12 14.6167 12 14.6167 12 14.8C12 14.9667 12 15.2083 12 15.525C12 15.6917 12 15.8417 12 15.975C12 16.0917 12 16.1833 12 16.25V16V26V16Z' fill='#01B3A8' />
    </svg>
  );
}
function ChatIcon(): JSX.Element {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='40' height='40' rx='8' fill='#D9F6F5' />
      <path d='M20 30L19.75 27H19.5C17.1333 27 15.125 26.175 13.475 24.525C11.825 22.875 11 20.8667 11 18.5C11 16.1333 11.825 14.125 13.475 12.475C15.125 10.825 17.1333 10 19.5 10C20.6833 10 21.7833 10.225 22.8 10.675C23.8333 11.1083 24.7333 11.7167 25.5 12.5C26.2833 13.2667 26.8917 14.1667 27.325 15.2C27.775 16.2167 28 17.3167 28 18.5C28 21.0333 27.2417 23.3083 25.725 25.325C24.2083 27.325 22.3 28.8833 20 30ZM19.475 23.975C19.7583 23.975 20 23.875 20.2 23.675C20.4 23.475 20.5 23.2333 20.5 22.95C20.5 22.6667 20.4 22.425 20.2 22.225C20 22.025 19.7583 21.925 19.475 21.925C19.1917 21.925 18.95 22.025 18.75 22.225C18.55 22.425 18.45 22.6667 18.45 22.95C18.45 23.2333 18.55 23.475 18.75 23.675C18.95 23.875 19.1917 23.975 19.475 23.975ZM19.5 20.8C19.6833 20.8 19.85 20.7333 20 20.6C20.15 20.4667 20.25 20.2833 20.3 20.05C20.3333 19.8333 20.425 19.6417 20.575 19.475C20.725 19.2917 20.9833 19.0167 21.35 18.65C21.65 18.35 21.9 18.025 22.1 17.675C22.3 17.325 22.4 16.95 22.4 16.55C22.4 15.7 22.1083 15.0667 21.525 14.65C20.9583 14.2167 20.2833 14 19.5 14C18.9167 14 18.4083 14.1333 17.975 14.4C17.5583 14.6667 17.2167 15 16.95 15.4C16.8333 15.5833 16.8083 15.775 16.875 15.975C16.9583 16.175 17.1167 16.3167 17.35 16.4C17.5167 16.4667 17.6833 16.4667 17.85 16.4C18.0167 16.3333 18.1667 16.2083 18.3 16.025C18.4333 15.8417 18.5917 15.6917 18.775 15.575C18.975 15.4583 19.2167 15.4 19.5 15.4C19.95 15.4 20.2833 15.525 20.5 15.775C20.7333 16.025 20.85 16.3 20.85 16.6C20.85 16.8833 20.7667 17.1417 20.6 17.375C20.4333 17.5917 20.2333 17.8167 20 18.05C19.5333 18.45 19.2167 18.775 19.05 19.025C18.9 19.275 18.8083 19.6167 18.775 20.05C18.7583 20.25 18.8167 20.425 18.95 20.575C19.1 20.725 19.2833 20.8 19.5 20.8ZM22 25V26.35C23.1833 25.35 24.1417 24.1833 24.875 22.85C25.625 21.5 26 20.05 26 18.5C26 16.6833 25.3667 15.15 24.1 13.9C22.85 12.6333 21.3167 12 19.5 12C17.6833 12 16.1417 12.6333 14.875 13.9C13.625 15.15 13 16.6833 13 18.5C13 20.3167 13.625 21.8583 14.875 23.125C16.1417 24.375 17.6833 25 19.5 25H22Z' fill='#01B3A8' />
    </svg>

  );
}

const ContactDefaultValues: IContactUs = {
  full_name: '',
  email: '',
  company: '',
  phone: '',
  message: '',
};

const schema = yup.object().shape({
  full_name: yup.string().trim().required('Please enter your Full Name').matches(/[A-Za-z]/, 'Please enter a valid Full Name'),
  email: yup.string().required('This field is required').email('Enter a valid email'),
  phone: yup.string().required('This field is required').matches(
    /\+[0-9]{1,3}\s\([0-9]{3}\)\s[0-9]{3}[-]?[0-9]{4}/,
    'Please enter a valid phone number',
  ),
  company: yup.string().required('This field is required'),
  message: yup.string().required('This field is required'),
});

export default function ContactUs(): JSX.Element {
  const { enqueueSnackbar } = useSnackbar();
  const [isSent, setIsSent] = useState(false);
  const {
    control, formState, handleSubmit, reset,
  } = useForm<IFormValues>({
    mode: 'onChange',
    defaultValues: ContactDefaultValues,
    resolver: yupResolver(schema),
  });

  const { errors } = formState;

  const { mutate: contactUs, isLoading } = useMutation(async (data: IContactUs) => axios({
    url: '/api/request_demo/',
    method: 'POST',
    data,
  }), {
    onSuccess: () => {
      setIsSent(true);
    },
    onError: () => {
      enqueueSnackbar('Request failed.');
    },
  });

  const onSubmit = (data: IContactUs): void => {
    contactUs(data);
    reset(ContactDefaultValues);
  };

  return (
    <>
      <div className='contactus-container'>
        <div className='contactus-wrappper'>
          {isSent && (
            <div className='thank-you-message'>
              <span><TickIcon /></span>
              Thank you! Message received. We’ll get back to you shortly!
            </div>
          )}
          <h1> Drop us a line</h1>

          <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>

            <div className='input-wrapper'>
              <div className='input-wrap'>
                <p className='input-label'>Full name *</p>
                <HookTextField
                  name='full_name'
                  control={control}
                  errors={errors}
                  type='text'
                  maxLength={150}
                />
              </div>
              <div className='input-wrap'>
                <p className='input-label'>Email *</p>
                <HookTextField
                  name='email'
                  control={control}
                  errors={errors}
                  type='text'
                  maxLength={150}
                />
              </div>
            </div>

            <div className='input-wrapper'>
              <div className='input-wrap'>
                <p className='input-label'>Company *</p>
                <HookTextField
                  name='company'
                  control={control}
                  errors={errors}
                  type='text'
                  maxLength={150}
                />
              </div>
              <div className='input-wrap'>
                <p className='input-label'>Phone *</p>
                <HookTextField
                  name='phone'
                  placeholder='+1 (555) 000-0000'
                  control={control}
                  errors={errors}
                  type='text'
                  // maxLength={17}
                />
              </div>
            </div>

            <div className='message-div'>
              <HookTextField
                name='message'
                placeholder='Enter your message...'
                control={control}
                errors={errors}
                type='text'
                multiline
                rows={5}
              />
            </div>
            <p className='invite-description'>
              <span> Your use of this website is subject to the Strada </span>
              <Link to='/terms-and-conditions'>Terms</Link>
              <span> and </span>
              <Link to='/privacy-policy'>Privacy Policy.</Link>
            </p>
            {!isLoading
              ? (
                <SecondaryButton2
                  type='submit'
                  fullWidth
                >
                  {' '}
                  Submit
                </SecondaryButton2>
              )
              : (
                <div className='progress-div'>
                  <CircularProgress style={{ width: '20px', height: '20px', color: '#A1A1AA' }} />
                </div>
              )}
          </form>
        </div>
      </div>

      {/* Office Location */}

      <div className='office-grid-container'>
        <div className='office-grid-item'>
          <AddressIcon />
          <p className='title'>Address</p>
          <p className='sub-title'>Come see us Mon - Fri 9am - 5pm</p>
          <p className='item'><a href='https://www.google.com/maps/place/25+Taylor+St,+San+Francisco,+CA+94102,+USA/@37.7824849,-122.4132493,17z/data=!3m1!4b1!4m6!3m5!1s0x808580851056caf3:0x2241308e9065ba58!8m2!3d37.7824849!4d-122.4110606!16s%2Fg%2F11c27g12pp' target='_blank' rel='noreferrer'>25 Taylor St, San Francisco, CA 94102</a></p>
        </div>
        <div className='office-grid-item'>
          <EmailIcon />
          <p className='title'>Email</p>
          <p className='sub-title'>Get in touch by leaving us an email</p>
          <p className='item'><a href='mailto:contact@strada.ai'>contact@strada.ai</a></p>
        </div>
        <div className='office-grid-item'>
          <ChatIcon />
          <p className='title'>Chat</p>
          <p className='sub-title'>Use our live chat and get quick reply</p>
          <p className='item'>Chat with us</p>
        </div>
      </div>
      <div className='strada-public-home'>
        <NewFooter />
      </div>
    </>
  );
}
